@let coupons = coupons$ | async;
@let summary = coupons?.meta?.summary;

<div class="coupons">
  <section class="coupons__summary-cards">
    @if (summary) {
      <app-status-summary-card
        label="CUPONS CRIADOS"
        colorVariant="cyan"
        [count]="summary.created"
        [active]="activeStatusFilter === null"
        (cardClick)="handleStatusFilter(null)" />
      <app-status-summary-card
        label="CUPONS ATIVOS"
        colorVariant="green"
        [count]="summary.active"
        [active]="activeStatusFilter === 'active'"
        (cardClick)="handleStatusFilter('active')" />
      <app-status-summary-card
        label="CUPONS ENCERRADOS"
        colorVariant="grey"
        [count]="summary.closed"
        [active]="activeStatusFilter === 'closed'"
        (cardClick)="handleStatusFilter('closed')" />
      <app-status-summary-card
        label="CUPONS CANCELADOS"
        colorVariant="red"
        [count]="summary.cancelled"
        [active]="activeStatusFilter === 'cancelled'"
        (cardClick)="handleStatusFilter('cancelled')" />
    } @else {
      <p-skeleton height="90px" />
      <p-skeleton height="90px" />
      <p-skeleton height="90px" />
      <p-skeleton height="90px" />
    }
  </section>

  <section class="coupons__search-section">
    <div class="coupons__search">
      <p class="coupons__search-label">BUSCAR CUPOM</p>
      <div class="coupons__search-field">
        <p-iconField iconPosition="left">
          <p-inputIcon>
            <i class="pi pi-search"></i>
          </p-inputIcon>
          <input pInputText [formControl]="tableFilter" placeholder="Digite o código do Cupom" />
        </p-iconField>
        @if (showSearchHint) {
          <small class="coupons__search-hint">Digite ao menos 3 caracteres para buscar.</small>
        }
      </div>
    </div>

    <div class="coupons__search-actions">
      @if (coupons && coupons.meta.total_count) {
        <app-paginator-report
          [meta]="coupons.meta"
          [template]="'Exibindo {first}–{last} de {totalRecords} resultados'" />
      }
      <app-button styleType="outlined" [disabled]="!hasActiveFilters" (btnClick)="clearFilters()">
        Limpar filtros
      </app-button>
      @if (!readOnly()) {
        <app-button icon="pi pi-plus" (btnClick)="openCreateModal()">Criar Cupom</app-button>
      }
    </div>
  </section>

  <section class="coupons__table-section">
    <app-coupon-table
      [data]="coupons"
      [filtered]="hasActiveFilters"
      [loading]="isLoading()"
      [sort]="sort"
      [direction]="direction"
      [readOnly]="readOnly()"
      (pageChange)="handlePageChange($event)"
      (sortChange)="handleSort($event)"
      (editClick)="openEditModal($event)"
      (deactivateClick)="handleDeactivate($event)"
      (viewDetailsClick)="handleViewDetails($event)" />
  </section>
</div>
